'use strict';

import angular from 'angular';

function PositionResource($resource) {
  return $resource('/api/groups/:groupId/positions/:id/:controller', {
    groupId: '@groupId', id: '@id'
  }, {
    getDescendents: {
      method: 'GET',
      isArray: true,
      params: { controller: 'descendents' }
    },
    update: {
      method: 'PUT'
    }
  });
}

PositionResource.$inject = ['$resource'];

export default angular.module('georgeApp.positionSvc', [])
  .factory('PositionSvc', PositionResource)
  .name;
